async function cartAdded() {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) {
    console.warn("cart-drawer not in DOM yet");
    return;
  }
  await drawer.refresh();
  await drawer.renderBasketQuantityIcon();
  drawer.open();
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.onKeyUp = this.onKeyUp.bind(this);
    this.cartItemControls = this.cartItemControls.bind(this);

    this.pendingQtyTimer = null;
    this.isOpen = false;
  }

  connectedCallback() {
    this.overlay = this.querySelector("[data-overlay]");
    this.panel = this.querySelector("[data-panel]");

    this.basketQuantityIcon = document.querySelector("#basketQuantityIcon");
    this.basketQuantityIconDesktop = document.querySelector(
      "#basketQuantityIconDesktop",
    );

    this.drawerSection =
      this.querySelector('[data-section-id="cart-drawer"]') || this;

    if (!this.overlay || !this.panel) {
      console.warn(
        "[CartDrawer] Missing [data-overlay] or [data-panel]. Check markup.",
      );
      return;
    }
    this.querySelectorAll("[data-cart-drawer-close]").forEach((btn) => {
      btn.addEventListener("click", () => this.close());
    });

    this.overlay.addEventListener("click", () => this.close());

    this.addEventListener("click", this.cartItemControls);

    document.addEventListener("cart:open", () => this.open());
    document.addEventListener("cart:close", () => this.close());

    // document.addEventListener("cart:added", async () => {
    //   await this.refresh();
    //   this.open();
    // });

    this.setClosedState(true);

    this.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-upsell-add]");
      if (!btn) return;

      const variantId = Number(btn.getAttribute("data-variant-id"));
      if (!variantId) return;

      this.addUpsellToCart(variantId);
    });
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.cartItemControls);
    document.removeEventListener("keyup", this.onKeyUp);
  }

  lockScroll() {
    this.scrollY = window.scrollY || window.pageYOffset;

    document.body.style.position = "fixed";
    document.body.style.top = `-${this.scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  }

  unlockScroll() {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";

    if (typeof this.scrollY === "number") {
      window.scrollTo(0, this.scrollY);
    }
  }

  open() {
    if (this.isOpen) return;
    this.isOpen = true;

    this.classList.remove("hidden");
    document.addEventListener("keyup", this.onKeyUp);
    requestAnimationFrame(() => {
      this.overlay.classList.remove("opacity-0");
      this.overlay.classList.add("opacity-100");

      this.panel.classList.remove("translate-x-full");
      this.panel.classList.add("translate-x-0");
    });
    this.lockScroll();
  }

  close() {
    if (!this.isOpen) return;
    this.isOpen = false;

    document.removeEventListener("keyup", this.onKeyUp);

    this.overlay.classList.remove("opacity-100");
    this.overlay.classList.add("opacity-0");

    this.panel.classList.remove("translate-x-0");
    this.panel.classList.add("translate-x-full");

    const duration = this.getTransitionDurationMs(this.panel) || 300;
    window.setTimeout(() => {
      if (!this.isOpen) this.classList.add("hidden");
    }, duration);
    this.unlockScroll();
  }

  async refresh() {
    const state = await this.fetchSections();
    this.renderSections(state);
  }

  onKeyUp(e) {
    if (e.key === "Escape") this.close();
  }

  cartItemControls(e) {
    const minus = e.target.closest("[data-qty-minus]");
    const plus = e.target.closest("[data-qty-plus]");
    const remove = e.target.closest("[data-remove]");

    if (minus || plus || remove) {
      e.preventDefault();

      const lineEl = e.target.closest("[data-key]");
      const key = lineEl?.getAttribute("data-key");
      if (!key) return;

      // REMOVE button
      if (remove) {
        const linkedKeys = this.getLinkedRemovalKeys(lineEl);
        this.removeKeys([key, ...linkedKeys]);
        return;
      }

      const input = lineEl.querySelector("[data-qty-input]");
      if (!input) return;

      const current = this.safeInt(input.value, 1);
      const next = minus ? Math.max(current - 1, 0) : current + 1;

      input.value = String(next);

      // If minus hits 0, remove linked products too (same behaviour as remove)
      if (next === 0) {
        const linkedKeys = this.getLinkedRemovalKeys(lineEl);
        this.removeKeys([key, ...linkedKeys]);
        return;
      }

      this.debouncedQtyUpdate(key, next);
      return;
    }

    const closeBtn = e.target.closest("[data-cart-drawer-close]");
    if (closeBtn) {
      e.preventDefault();
      this.close();
      return;
    }
  }

  async removeKeys(keys) {
    const uniqueKeys = [...new Set(keys)].filter(Boolean);
    for (const k of uniqueKeys) {
      await this.updateLineItem(k, 0);
    }
  }

  getLinkedRemovalKeys(lineEl) {
    const root = this.closest("cart-drawer") || document; // scope to drawer
    const itemBox = lineEl.closest("[data-key]"); // THIS is where your attrs are
    if (!itemBox) return [];

    const productTitle = (itemBox.dataset.productTitle || "").trim();
    if (!productTitle) return [];

    const parentCartElement = itemBox.closest(".cart-item")?.parentElement;
    if (!parentCartElement) return [];

    const keysToRemove = new Set();

    const addMatchesByVariantId = (variantId) => {
      if (!variantId) return;

      parentCartElement
        .querySelectorAll(`[data-productid="${CSS.escape(String(variantId))}"]`)
        .forEach((linkedBox) => {
          const forText = linkedBox
            .querySelector(".properties-installation-for")
            ?.textContent?.trim();

          if (forText === productTitle) {
            const linkedKey = linkedBox.getAttribute("data-key");
            if (linkedKey) keysToRemove.add(linkedKey);
          }
        });
    };

    // These tiles live inside the SAME cart item block
    const installationTile = itemBox.querySelector(
      ".professional-installation-tile",
    );
    if (installationTile?.dataset.disableInstallation === "true") {
      addMatchesByVariantId(installationTile.dataset.installationId);
    }

    const diyKitTile = itemBox.querySelector(".diy-kit-tile");
    if (diyKitTile?.dataset.disableInstallation === "true") {
      addMatchesByVariantId(diyKitTile.dataset.kitId);
    }

    return [...keysToRemove];
  }

  debouncedQtyUpdate(key, qty) {
    window.clearTimeout(this.pendingQtyTimer);
    this.pendingQtyTimer = window.setTimeout(() => {
      this.updateLineItem(key, qty);
    }, 250);
  }

  async hydrateUpsells(rootEl = document) {
    const slots = Array.from(rootEl.querySelectorAll("[data-cart-upsell]"));
    if (!slots.length) return;

    for (const slot of slots) {
      const productId = Number(slot.getAttribute("data-base-product-id"));
      if (!productId) continue;
      if (slot.querySelector("[data-upsell-card]")) continue;

      try {
        const rec = await this.fetchRecommendation(productId);
        const product = rec?.products?.[0];

        if (!product) {
          slot.innerHTML = "";
          continue;
        }

        slot.innerHTML = this.renderUpsellCard(product);
      } catch (err) {
        console.warn("[hydrateUpsells] failed", err);
        slot.innerHTML = "";
      }
    }
  }

  fetchRecommendation(productId) {
    const root =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : "/";
    const url = new URL(
      `${root}recommendations/products.json`,
      window.location.origin,
    );
    url.searchParams.set("product_id", String(productId));
    url.searchParams.set("limit", "1");

    return fetch(url.toString(), {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    }).then((r) => {
      if (!r.ok) throw new Error(`recommendations failed: ${r.status}`);
      return r.json();
    });
  }

  renderUpsellCard(product) {
    const title = product.title || "Recommended";
    const url = product.url || "#";
    const image =
      product.featured_image || (product.images && product.images[0]) || null;
    const variant =
      (product.variants || []).find((v) => v.available) ||
      (product.variants || [])[0];
    const variantId = variant?.id;

    const priceCents = variant?.price ?? product.price;
    const priceText =
      typeof priceCents === "number" ? this.formatMoney(priceCents) : "";

    return `
      <div class="border border-primaryGreen rounded-sm relative py-[14px] px-6 mb-8" data-upsell-card>
        <p class="font-bold font-montserrat text-base mb-4">Frequently bought with</p>

        <div class="flex gap-5 items-center font-montserrat">
          <div class="border border-lightGray rounded-sm w-[86px] h-[92px] p-2">
            ${image ? `<img src="${image}" alt="${this.escapeHtml(title)}" class="object-contain w-full h-full" loading="lazy">` : ""}
          </div>
          <div class="flex-1">
            <pclass="text-base font-bold">${this.escapeHtml(title)}</p>
            ${priceText ? `<p class="text-base font-light">+${priceText}</p>` : ""}
          </div>
        </div>

        <div class="absolute left-1/2 -bottom-4">
          ${
            variantId
              ? `
            <button
              type="button"
              class="bg-primaryGreen hover:bg-navyDarkBlue transltion-all duration-150 text-base font-bold font-montserrat py-2 px-8 text-white -translate-x-1/2"
              data-upsell-add
              data-variant-id="${variantId}"
            >
              Add
            </button>
          `
              : ""
          }
        </div>
      </div>
    `;
  }

  formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents);
    }
    return `£${(cents / 100).toFixed(2)}`;
  }

  escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  async updateLineItem(key, quantity) {
    try {
      const res = await fetch(
        `${window.Shopify?.routes?.root || "/"}cart/change.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: key, quantity }),
        },
      );

      if (!res.ok) throw new Error(`cart/change.js failed: ${res.status}`);
      await this.refresh();
      this.open();
    } catch (err) {
      console.error("[CartDrawer] updateLineItem error:", err);
    }
  }

  getSectionsToRender() {
    const raw = this.getAttribute("data-sections") || "cart-drawer";
    return raw
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }

  async fetchSections() {
    const sections = this.getSectionsToRender();

    const root =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : "/";
    const url = new URL(root, window.location.origin);

    url.searchParams.set("sections", sections.join(","));

    const res = await fetch(url.toString(), {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });

    if (!res.ok) throw new Error(`sections fetch failed: ${res.status}`);

    const json = await res.json();

    return json.sections ? json.sections : json;
  }

  async renderBasketQuantityIcon() {
    try {
      const response = await fetch(window.location.pathname);
      if (!response.ok) throw new Error(`http error`);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const newBasketQuantityIcon = html.querySelector("#basketQuantityIcon");
      const newBasketQuantityIconDesktop = html.querySelector(
        "#basketQuantityIconDesktop",
      );

      if (!newBasketQuantityIcon || !newBasketQuantityIconDesktop) return;
      this.basketQuantityIcon.innerHTML = newBasketQuantityIcon.innerHTML;
      updateCartQuantityIcon(newBasketQuantityIconDesktop.innerHTML);
    } catch (error) {
      console.error(error);
    }
  }

  async addUpsellToCart(variantId) {
    const root =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : "/";

    await fetch(`${root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    const state = await this.fetchSections();
    this.renderSections(state);
  }

  renderSections(state) {
    this.renderBasketQuantityIcon();
    Object.entries(state).forEach(([sectionId, html]) => {
      if (!html) {
        console.warn(`[renderSections] section "${sectionId}" is null/empty`);
        return;
      }
      const doc = new DOMParser().parseFromString(html, "text/html");
      const incoming =
        doc.querySelector(`[data-section-id="${sectionId}"]`) ||
        doc.querySelector(`#shopify-section-${sectionId}`);
      if (!incoming) {
        console.warn(
          `[renderSections] Could not find incoming markup for "${sectionId}"`,
        );
        return;
      }
      const targets = document.querySelectorAll(
        `[data-section-id="${sectionId}"]`,
      );

      if (!targets.length) {
        console.warn(
          `[renderSections] Could not find current target(s) for "${sectionId}" on page`,
        );
        return;
      }

      targets.forEach((current) => {
        //For dynamic buttons - we do not want to re-render them. Keep as is
        const preserved = current.querySelector(
          "[data-cart-checkout-preserve]",
        );
        current.innerHTML = incoming.innerHTML;

        if (preserved) {
          const placeholder = current.querySelector(
            "[data-cart-checkout-preserve]",
          );
          if (placeholder) placeholder.replaceWith(preserved);
        }
      });
    });

    //Update shipping bar
    updateShippingBar();
    this.hydrateUpsells(this);
  }

  parseHTML(htmlString) {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    return doc.body.innerHTML;
  }

  setClosedState(initial = false) {
    if (initial) {
      this.overlay.classList.add("opacity-0");
      this.overlay.classList.remove("opacity-100");

      this.panel.classList.add("translate-x-full");
      this.panel.classList.remove("translate-x-0");
    }
  }

  getTransitionDurationMs(el) {
    if (!el) return 0;
    const styles = window.getComputedStyle(el);
    const dur = styles.transitionDuration || "0s";
    const first = dur.split(",")[0].trim();
    if (first.endsWith("ms")) return this.safeInt(first.replace("ms", ""), 0);
    if (first.endsWith("s"))
      return Math.round(parseFloat(first.replace("s", "")) * 1000);
    return 0;
  }

  safeInt(value, fallback = 0) {
    const n = parseInt(value, 10);
    return Number.isFinite(n) ? n : fallback;
  }
}

customElements.define("cart-drawer", CartDrawer);

window.addEventListener("DOMContentLoaded", () => {
  window.cartDrawer = document.querySelector("cart-drawer#CartDrawer") || null;
});
